import { render, staticRenderFns } from "./ClubView.vue?vue&type=template&id=e883de36&scoped=true&"
import script from "./ClubView.vue?vue&type=script&lang=js&"
export * from "./ClubView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e883de36",
  null
  
)

export default component.exports